/**
 * Mode-aware navigation hook
 * Ensures navigation always maintains the current mode context
 */

import { useNavigate, useParams } from 'react-router';
import { getAppMode, getUrlId, isValidTemplate } from '../utils/appConfig';

export const useAppNavigate = () => {
  const navigate = useNavigate();
  const mode = getAppMode();
  const urlId = getUrlId();

  return (to: string) => {
    // Clean the path - remove leading slash if present
    const cleanPath = to.startsWith('/') ? to.slice(1) : to;
    const finalPath = cleanPath === '' ? '' : `/${cleanPath}`;

    if (mode === "edit" && urlId) {
      // Edit mode: /restaurant-id/preview/edit/path
      navigate(`/${urlId}/preview/edit${finalPath}`);
    } else if (mode === "preview" && urlId && isValidTemplate(urlId)) {
      // Preview mode: /template-name/preview/path (e.g., /pizza/preview/menu)
      navigate(`/${urlId}/preview${finalPath}`);
    } else {
      // Normal mode: /path
      navigate(finalPath || '/');
    }
  };
};

export default useAppNavigate;
